const initialState = {
  isFetchingCouncils: true,
  activeCouncil: null,
  comparedCouncil: null,
  activeEntity: null,
  comparedEntity: null,
  activePage: 'search',
  isMobile: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'REGIONS_ALL:REQUEST': {
      return {
        ...state,
        isFetchingCouncils: true,
      };
    }
    case 'REGIONS_ALL:SUCCESS': {
      return {
        ...state,
        isFetchingCouncils: false,
      };
    }
    case 'REGION:SET_ACTIVE': {
      return {
        ...state,
        activeCouncil: action.payload.id,
      };
    }
    case 'REGION:SET_COMPARED': {
      return {
        ...state,
        comparedCouncil: action.payload.id,
      };
    }
    case 'ENTITY:SET_ACTIVE': {
      return {
        ...state,
        activeEntity: action.payload.id,
      };
    }
    case 'ENTITY:SET_COMPARED': {
      return {
        ...state,
        comparedEntity: action.payload.id,
      };
    }
    case 'PAGE:SET_ACTIVE': {
      return {
        ...state,
        activePage: action.payload.name,
      };
    }
    case 'SET_IS_MOBILE': {
      return { ...state, isMobile: action.payload };
    }
    default: {
      return state;
    }
  }
};

export const getIsFetchingCouncils = state => state.isFetchingCouncils;
export const getActiveCouncil = state => state.activeCouncil;
export const getActiveEntity = state => state.activeEntity;
export const getComparedCouncil = state => state.comparedCouncil;
export const getComparedEntity = state => state.comparedEntity;
export const getActivePage = state => state.activePage;
export const getIsMobile = state => state.isMobile;



// WEBPACK FOOTER //
// ./src/reducers/ui.js